import { shade } from 'polished';
import styled from 'styled-components';

export const ListPanel = styled.div`
    width: 15%;
    height: 100%;
    background-color: ${props => {
        const color = props.theme.palette.primary.main;
        return shade(0.97, color);
    }};
    border-right: 1px solid #555555;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SearchDiv = styled.div`
    width: 100%;
    height: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    font-size: 1.25vh !important;
    border-bottom: 1px solid #555555;

    h3 {
        font-size: 1.875vh;
        font-weight: bold;
        color: #eee;
        text-align: center;
        margin-bottom: 20px;
    }

    .filter-field {
        width: 85%;
        margin: 2vh 0px;
        background-color: #38424b;
        * {
            font-size: 1.25vh !important;
            color: #eee;
        }
    }
`;

export const ListDiv = styled.div`
    height: 85%;
    width: 100%;
    font-size: 1.35vh !important;

    ul {
        margin: 0px;
        padding: 0px;
        padding-bottom: 200px;

        .active {
            background-color: rgba(0, 0, 0, 0.5);
            border-right: 0.25vw solid
                ${props => props.theme.palette.primary.main};
        }
    }
`;
